const generateRandomNumber = (limit = 10000) => Math.floor(Math.random() * limit) + 1000;

export default generateRandomNumber;
